export * from './terms-text.component';
